import {useMemo, useState} from "react";
import {ServiceTypeFacetModeEntity} from "@ots-frontend/ots-data";
import {useDebouncedValue} from "@mantine/hooks";
import {
  DataTableFilterConfig,
  useDataTableFilter,
  UseDataTableFilterProps,
  UseDataTableFilterResult
} from "../DataTable/useDataTableFilter";
import {useTranslation} from "react-i18next";

export type UseServiceTypeFacetModeDataTableFilterProps = Omit<UseDataTableFilterProps<ServiceTypeFacetModeEntity>, 'filterConfig'>

export function useServiceTypeFacetModeDataTableFilter(props: UseServiceTypeFacetModeDataTableFilterProps): UseDataTableFilterResult<ServiceTypeFacetModeEntity> {
  const {records} = props;

  const {t} = useTranslation(["common"])

  const [facetQuery, setFacetQuery] = useState<string | undefined>(undefined);
  const [facetDebouncedQuery] = useDebouncedValue(facetQuery, 200);

  const [modeQuery, setModeQuery] = useState<string | undefined>(undefined);
  const [modeDebouncedQuery] = useDebouncedValue(modeQuery, 200);

  const filterConfig: DataTableFilterConfig<ServiceTypeFacetModeEntity> = useMemo(() => {
    return {
      "facet": {
        setQuery: setFacetQuery,
        query: facetQuery,
        debouncedQuery: facetDebouncedQuery,
        filter: (record, query) => !record.facet.toLowerCase().includes(query.toLowerCase())
      },
      "mode": {
        setQuery: setModeQuery,
        query: modeQuery,
        debouncedQuery: modeDebouncedQuery,
        filter: (record, query) => !record.mode.toLowerCase().includes(query.toLowerCase())
      },
    }
  }, [
    facetQuery,
    facetDebouncedQuery,
    modeQuery,
    modeDebouncedQuery,
    t
  ])

  const {filteredRecords} = useDataTableFilter({
    records: records,
    filterConfig: filterConfig,
  })

  return {
    filteredRecords: filteredRecords,
    filterConfig: filterConfig
  };
}
